<template>
    <div>
        <h5>When would you like to park?</h5>
        <div class="btn-group">
            <label>
                <label
                    :class="{
                        'btn-default': booking_type !== 'now',
                        'btn-green': booking_type === 'now'
                    }"
                    class="btn"
                >
                    Now
                    <input
                        v-model="booking_type"
                        type="radio"
                        name="bookingType"
                        value="now"
                        data-no-style
                    >
                </label>
            </label>
            <label v-if="canPrebook && !canPastbook.allow">
                <label
                    :class="{
                        'btn-default': booking_type !== 'future',
                        'btn-green': booking_type === 'future'
                    }"
                    class="btn"
                >
                    Later
                    <input
                        v-model="booking_type"
                        type="radio"
                        name="bookingType"
                        value="future"
                        data-no-style
                    >
                </label>
            </label>
            <label v-else-if="canPastbook.allow && !canPrebook">
                <label
                    :class="{
                        'btn-default': booking_type !== 'past',
                        'btn-green': booking_type === 'past'
                    }"
                    class="btn"
                >
                    Earlier
                    <input
                        v-model="booking_type"
                        type="radio"
                        name="bookingType"
                        value="past"
                        data-no-style
                    >
                </label>
            </label>
            <label v-else>
                <label
                    :class="{
                        'btn-default': booking_type !== 'past',
                        'btn-green': booking_type === 'past'
                    }"
                    class="btn"
                >
                    Earlier/Later
                    <input
                        v-model="booking_type"
                        type="radio"
                        name="bookingType"
                        value="past"
                        data-no-style
                    >
                </label>
            </label>
        </div>
    </div>
</template>

<script>
    import storeFormSync from '../../../../store/form-sync';

    export default {
        name: 'pay-by-phone-toggle',

        props: {
            canPrebook: {
                type: Boolean,
                default() {
                    return false;
                },
            },

            canPastbook: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...storeFormSync([
                'booking.reservation_details.booking_type',
            ]),
        },
    }
</script>
